import { Box, Divider, Grid } from '@material-ui/core'
import { MouseEvent, useState } from 'react'

import { useGetHerbicideTreatments } from '@/hooks/queries/use-get-herbicide-treatments'
import { HerbicideTreatment } from '@/services/get-herbicide-treatments'

import { Header } from './components/header'
import { HerbicideTreatmentItem } from './components/herbicide-treatment-item'
import { HerbicideTreatmentMenu } from './components/herbicide-treatment-menu'
import { SaveHerbicideTreatment } from './components/save-herbicide-treatment'
import { Skeleton } from './components/skeleton'

export function Herbicides() {
  const [menu, setMenu] = useState<HTMLElement | null>(null)
  const [selectedTreatment, setSelectedTreatment] =
    useState<HerbicideTreatment | null>(null)

  const [
    isShowSaveHerbicideTreatmentCard,
    setIsShowSaveHerbicideTreatmentCard,
  ] = useState(false)

  const { data, isLoading } = useGetHerbicideTreatments()

  function handleOpenMenu(
    event: MouseEvent<HTMLButtonElement>,
    herbicideTreatment: HerbicideTreatment,
  ) {
    setMenu(event.currentTarget)
    setSelectedTreatment(herbicideTreatment)
    setIsShowSaveHerbicideTreatmentCard(false)
  }

  function handleCloseMenu() {
    setMenu(null)
  }

  function handleCreateNewHerbicideTreatment() {
    if (selectedTreatment) {
      setIsShowSaveHerbicideTreatmentCard(false)

      setTimeout(() => {
        setIsShowSaveHerbicideTreatmentCard(true)
      }, 100)
    } else {
      setIsShowSaveHerbicideTreatmentCard(true)
    }

    resetListScroll()
    clearSelectedHerbicideTreatment()
  }

  function handleCloseSaveHerbicideTreatmentCard() {
    clearSelectedHerbicideTreatment()
    setIsShowSaveHerbicideTreatmentCard(false)
  }

  function handleEditHerbicideTreatment() {
    setTimeout(() => {
      resetListScroll()
    }, 100)
    setIsShowSaveHerbicideTreatmentCard(true)
    handleCloseMenu()
  }

  function resetListScroll() {
    document.querySelector('#scrollContainer')?.scrollTo(0, 0)
  }

  function clearSelectedHerbicideTreatment() {
    setSelectedTreatment(null)
  }

  return (
    <>
      <Header
        onCreateNewHerbicideTreatment={handleCreateNewHerbicideTreatment}
      />

      <Divider />

      <Box id={'scrollContainer'} overflow={'auto'}>
        {isShowSaveHerbicideTreatmentCard && (
          <SaveHerbicideTreatment
            onClose={handleCloseSaveHerbicideTreatmentCard}
            isEditing={Boolean(selectedTreatment)}
            selectedHerbicideTreatment={selectedTreatment}
          />
        )}

        <Box padding={'1rem'}>
          <Grid container spacing={2}>
            {!data && isLoading ? (
              <Skeleton />
            ) : (
              data?.map((item) => (
                <Grid key={item.id} item md={6} xs={12}>
                  <HerbicideTreatmentItem
                    herbicideTreatment={item}
                    onOpenMenu={handleOpenMenu}
                  />
                </Grid>
              ))
            )}
          </Grid>
        </Box>
      </Box>

      <HerbicideTreatmentMenu
        menu={menu}
        selectedHerbicideTreatment={selectedTreatment}
        onCloseMenu={handleCloseMenu}
        clearSelectedHerbicideTreatment={clearSelectedHerbicideTreatment}
        onEditHerbicideTreatment={handleEditHerbicideTreatment}
      />
    </>
  )
}
